

document.addEventListener('DOMContentLoaded', function () {
  const content = document.querySelector('.article-template__content');
  if (!content) return;

  const observer = new MutationObserver(() => {
    console.log('MutationObserver fired');
    // 画像を取得してスライダー作成関数を呼ぶ
    initSwiper();
    observer.disconnect();  // 一度だけ動かすなら切断
  });

  observer.observe(content, { childList: true, subtree: true });

  // 最初の一回も実行するため
  initSwiper();

  function initSwiper() {
    const images = Array.from(content.querySelectorAll('img'));
    if (images.length === 0) return;

    // すでにswiperがあれば初期化前に破棄するか処理を分ける（任意）
    if (content.querySelector('.swiper')) return;

    // スライダー構造作成
    const swiperContainer = document.createElement('div');
    swiperContainer.classList.add('swiper');

    const swiperWrapper = document.createElement('div');
    swiperWrapper.classList.add('swiper-wrapper');

    images.forEach(img => {
      const slide = document.createElement('div');
      slide.classList.add('swiper-slide');
      slide.appendChild(img);
      swiperWrapper.appendChild(slide);
    });

    swiperContainer.appendChild(swiperWrapper);

    const pagination = document.createElement('div');
    pagination.classList.add('swiper-pagination');
    swiperContainer.appendChild(pagination);

    // images.forEach(img => img.remove());//

    content.prepend(swiperContainer);

    new Swiper('.article-template__content .swiper', {
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  }
});